'use strict';

Object.defineProperty(exports, '__esModule', {
	value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function Controller($filter, $scope, $state, AppConstants, PageHeading, PromotionComponent, Promotion, Toast) {
	'ngInject';

	var vm = this;
	vm.editPromotion = editPromotion;
	vm.promotion = Promotion;
	vm.languages = AppConstants.languages;
	vm.yesterdayDate = new Date();
	vm.yesterdayDate.setDate(vm.yesterdayDate.getDate() - 1);

	activate();

	function activate() {
		var heading = $filter('translate')('HEADING.EDITING_PROMOTION');
		var title = 'BTMS | ' + $filter('translate')('HEADING.EDITING_PROMOTION');

		PageHeading.setPageHeading(heading, title);

		vm.promotion.value = parseFloat(vm.promotion.value);

		vm.languages.forEach(function (lang) {
			if (!_lodash2['default'].find(vm.promotion.translations, { 'lang': lang })) {
				vm.promotion.translations.push({ 'lang': lang, 'name': '' });
			}
		});
	}

	function editPromotion(params) {
		var hasErrors = false;

		angular.forEach($scope.editPromotion.$error.required, function () {
			hasErrors = true;

			return false;
		});

		if (hasErrors || $scope.editPromotion.value.$error.min || !vm.promotion.type) {
			Toast.error($filter('translate')('ERRORS.GENERAL'));

			return false;
		}

		PromotionComponent.updatePromotion(vm.promotion.id, params).then(function (res) {
			if (res.data.errors) {
				Toast.responseError(res.data.errors);
			} else {
				Toast.success($filter('translate')('SUCCESS.UPDATE_PROMOTION'));
				$state.go('app.private.promotions.list');
			}
		});
	}
}

exports['default'] = Controller;
module.exports = exports['default'];


/** WEBPACK FOOTER **
 ** ./client/private/promotions/edit/edit.controller.js
 **/